import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { Subscription } from "rxjs";
import { BroadcastService } from 'root/services';

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';


@Component({
  templateUrl: './dashboard-myfeatures.component.html',
  styleUrls: ['./dashboard-myfeatures.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent]
})
export class MibpDashboardMyFeaturesComponent implements OnInit, OnDestroy {
  private broadcast = inject(BroadcastService);

  userSub?: Subscription;
  features: string[];

  constructor() {}

  ngOnInit(): void {
    this.userSub = this.broadcast.mibpSession.subscribe(e => this.features = e.user?.enabledFeatures);
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

}
